import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logoo.webp';
import logoBelo from '../assets/lazarbelo.webp';
import './Navbar.css';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuOpen && !e.target.closest('.navbar')) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [menuOpen]);

    const isActive = (path) => location.pathname === path;

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
            <div className="nav-content">

                <div className="nav-links-left desktop-nav">
                    <Link to="/#onama" className="nav-item">Über uns</Link>
                    <Link to="/usluge" className={`nav-item ${isActive('/usluge') ? 'active-nav' : ''}`}>Leistungen</Link>
                </div>

                <Link to="/" className="nav-logo">
                    <img src={scrolled ? logo : logoBelo} alt="LuckyGarden" />
                </Link>

                <div className="nav-links-right desktop-nav">
                    <Link to="/portfolio" className={`nav-item ${isActive('/portfolio') ? 'active-nav' : ''}`}>Referenzen</Link>
                    <Link to="/contact" className={`nav-item ${isActive('/contact') ? 'active-nav' : ''}`}>Kontakt</Link>
                </div>

                <button
                    className="hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Menü öffnen"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
                <Link to="/#onama" className="mobile-nav-item">Über uns</Link>
                <Link to="/usluge" className={`mobile-nav-item ${isActive('/usluge') ? 'active-nav' : ''}`}>Leistungen</Link>
                <Link to="/portfolio" className={`mobile-nav-item ${isActive('/portfolio') ? 'active-nav' : ''}`}>Referenzen</Link>
                <Link to="/contact" className={`mobile-nav-item ${isActive('/contact') ? 'active-nav' : ''}`}>Kontakt</Link>
            </div>
        </nav>
    );
};

export default Navbar;
